export default __webpack_public_path__ + "static/media/finished.a38041d1.png";